/**
 * Customer-visible ticket status. Deliberately a small, stable set that hides
 * Linear's internal workflow. Mapped from a Linear workflow state's `type`
 * (triage | backlog | unstarted | started | completed | canceled), which is
 * stable across teams and custom state names.
 */
export type TicketStatus = "submitted" | "in_progress" | "resolved" | "closed";

export const TICKET_STATUS_LABEL: Record<TicketStatus, string> = {
  submitted: "Submitted",
  in_progress: "In progress",
  resolved: "Resolved",
  closed: "Closed",
};

/** Map a Linear state `type` to a customer-visible status. */
export function ticketStatusFromLinearType(stateType: string): TicketStatus {
  switch (stateType) {
    case "started":
      return "in_progress";
    case "completed":
      return "resolved";
    case "canceled":
      return "closed";
    // triage, backlog, unstarted, and anything unrecognized read as "submitted".
    default:
      return "submitted";
  }
}

/** Customer-selectable priority, mapped to Linear's 0-4 priority scale. */
export type TicketPriority = "low" | "normal" | "high" | "urgent";

export const TICKET_PRIORITIES: readonly TicketPriority[] = ["low", "normal", "high", "urgent"];

export const TICKET_PRIORITY_LABEL: Record<TicketPriority, string> = {
  low: "Low",
  normal: "Normal",
  high: "High",
  urgent: "Urgent",
};

/** Linear priority: 0 none, 1 urgent, 2 high, 3 normal, 4 low. */
export function linearPriorityFromTicket(priority: TicketPriority): number {
  switch (priority) {
    case "urgent":
      return 1;
    case "high":
      return 2;
    case "normal":
      return 3;
    case "low":
      return 4;
  }
}
